var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 12.9945C2.3999 8.46905 2.3999 6.20631 3.80579 4.80042C5.21168 3.39453 7.47442 3.39453 11.9999 3.39453C16.5254 3.39453 18.7881 3.39453 20.194 4.80042C21.5999 6.20631 21.5999 8.46905 21.5999 12.9945C21.5999 17.52 21.5999 19.7828 20.194 21.1886C18.7881 22.5945 16.5254 22.5945 11.9999 22.5945C7.47442 22.5945 5.21168 22.5945 3.80579 21.1886C2.3999 19.7828 2.3999 17.52 2.3999 12.9945Z",
    stroke: "#1552E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5999 12.9946L11.9999 12.9946M11.9999 12.9946L8.3999 12.9946M11.9999 12.9946L11.9999 9.39453M11.9999 12.9946L11.9999 16.5945",
    stroke: "#1552E8",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.4bc41a88fd5de176e52d9f6220a1c03d.svg";
export { ForwardRef as ReactComponent };